export default "__VITE_ASSET__DG6VYKdB__"